import config from '../config'
import http from '../http'

export default{
	updataGroupFee:async function(payload) {
		const res = await http({
			url: config.UPDATE_GRUOP_COST,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	updateGroupInfo:async function(payload) {
		const res = await http({
			url: config.UPDATE_GROUP_INFO,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getHistoryCostName:async function(payload) {
		const res = await http({
			url: config.GET_HISTORY_COST_NAME,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	deleteShopGroup:async function(payload) {
		const res = await http({
			url: config.DELETE_SHOP_GROUP,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	deleteGroupCost:async function(payload) {
		const res = await http({
			url: config.DELETE_GRUOP_COST,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	insetGroupCost:async function(payload) {
		const res = await http({
			url: config.INSET_GRUOP_COST,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	bindShopGroup:async function(payload) {
		const res = await http({
			url: config.BIND_SHOP_GRUOP,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	deleteUserGroup:async function(payload) {
		const res = await http({
			url: config.DELETE_GRUOP,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getUserGroup:async function(payload) {
		const res = await http({
			url: config.GET_USER_GROUP,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	createShopGroup:async function(payload) {
		const res = await http({
			url: config.CREATE_GRUOP,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
}
